import { fetchRewards, addReward, editReward, removeReward } from "../actions/rewards_action";
import { fetchRewardsMeta, editRewardsMeta } from "../actions/rewards_meta_action";
import Helping from "../helpers/Helping";
import Service from "../helpers/service";
import { API_URL } from '../config/urls';
import { GET_REWARDS } from '../config/routes';
import { trackPromise } from 'react-promise-tracker';

let updateCallback = (res) => {

}
export const setRewardError = (callback) => {

    updateCallback = callback;

}

export const getAll = (page, limit, search, sorting, sort_type) => {
    const params = `?page=${page}&limit=${limit}&search=${search}&sorting=${sorting}&sort_type=${sort_type}`;

    return dispatch => {
        return trackPromise(
            Service.getCall(API_URL.ADMIN_COLLECTION_API + GET_REWARDS + params, Helping.getConfig()).then(response => {
                let total = response.data.message.total;
                dispatch(fetchRewards(response.data.message.rewards));
                return dispatch(fetchRewardsMeta({
                    page: page,
                    limit: limit,
                    sorting: sorting,
                    sort_type: sort_type,
                    search: search,
                    total: total,
                    no_Of_pages: Math.ceil(total / limit)
                }));
            }).catch(error => {
                Helping.redirectToLogin(error);
                dispatch(fetchRewards([]));
                dispatch(fetchRewardsMeta({
                    page: page,
                    limit: limit,
                    sorting: sorting,
                    sort_type: sort_type,
                    search: search,
                    total: 0,
                    no_Of_pages: page
                }));
                console.log('error while fetching rewards: ', error);
                return updateCallback({
                    ...Helping.setNetworkRequestError(error, "fetching rewards")
                })
            })
        )
    };
};

export const create = (data) => {
    return dispatch => {
        dispatch(addReward(data));
    };
};

export const update = (data) => {
    return dispatch => {
        dispatch(editReward(data));
    };
};

export const updateRewardMeta = (payload) => {
    //console.log('in update ',{payload});
    return dispatch => {
        dispatch(editRewardsMeta(payload));
    };
};

export const remove = (id) => {
    return dispatch => {
        dispatch(removeReward(id));
    }
}
